// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS FORMTITLEINPUT.JS */

/* Style normal */
.titrFormulaire.ant-input {
  /* border-bottom: 1.5px solid #E0E0E0;  */
  transition: border-color 0.3s ease;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 24px;
  margin-top: -1.5%;
}
/* Style quand le champ est en focus */
.titrFormulaire.ant-input:focus,
.titrFormulaire.ant-input-focused {
  border-bottom: 2px solid #4C2B87; 
  box-shadow: none;
  outline: none;
  padding: 2%;
  line-height: 1.25;
  letter-spacing: 0;
}


/* Style normal */
.titrFormulaire2.ant-input {
  border-radius: 0;
  font-family: 'Roboto', sans-serif;
  font-size: 18px;
}
/* Style quand le champ est en focus */
.titrFormulaire2.ant-input:focus,
.titrFormulaire2.ant-input-focused {
  border-bottom: 2px solid #000; 
  width: auto;
  line-height: 1.25;
  letter-spacing: 0;
}



/* CSS POUR DESCRIPTIONINPUT.JS */

.inputDescriptionTitle.ant-input {
  /* border-bottom: 1.5px solid #E0E0E0;  */
  transition: border-color 0.3s ease;
  border-radius: 0;
  box-shadow: none;
  font-family: 'Roboto';
    font-weight: 400;
    font-size: 11pt;
    padding: 0;
}
/* Style quand le champ est en focus */
.inputDescriptionTitle.ant-input:focus,
.inputDescriptionTitle.ant-input-focused {
  border-bottom: 2px solid #4C2B87; 
  /* box-shadow: none; */
  line-height: 1.5;
  letter-spacing: 0;
  padding: 2%;
  /* outline: none; */
}`, "",{"version":3,"sources":["webpack://./src/components/forms/shared/shared.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B,iBAAiB;AACjB;EACE,yCAAyC;EACzC,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA,sCAAsC;AACtC;;EAEE,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;;AAGA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;AACA,sCAAsC;AACtC;;EAEE,6BAA6B;EAC7B,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;;;AAIA,iCAAiC;;AAEjC;EACE,yCAAyC;EACzC,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;IACnB,gBAAgB;IAChB,eAAe;IACf,UAAU;AACd;AACA,sCAAsC;AACtC;;EAEE,gCAAgC;EAChC,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB","sourcesContent":["/* CSS FORMTITLEINPUT.JS */\r\n\r\n/* Style normal */\r\n.titrFormulaire.ant-input {\r\n  /* border-bottom: 1.5px solid #E0E0E0;  */\r\n  transition: border-color 0.3s ease;\r\n  border-radius: 0;\r\n  box-shadow: none;\r\n  padding: 0;\r\n  font-family: 'Roboto', sans-serif;\r\n  font-weight: 400;\r\n  font-size: 24px;\r\n  margin-top: -1.5%;\r\n}\r\n/* Style quand le champ est en focus */\r\n.titrFormulaire.ant-input:focus,\r\n.titrFormulaire.ant-input-focused {\r\n  border-bottom: 2px solid #4C2B87; \r\n  box-shadow: none;\r\n  outline: none;\r\n  padding: 2%;\r\n  line-height: 1.25;\r\n  letter-spacing: 0;\r\n}\r\n\r\n\r\n/* Style normal */\r\n.titrFormulaire2.ant-input {\r\n  border-radius: 0;\r\n  font-family: 'Roboto', sans-serif;\r\n  font-size: 18px;\r\n}\r\n/* Style quand le champ est en focus */\r\n.titrFormulaire2.ant-input:focus,\r\n.titrFormulaire2.ant-input-focused {\r\n  border-bottom: 2px solid #000; \r\n  width: auto;\r\n  line-height: 1.25;\r\n  letter-spacing: 0;\r\n}\r\n\r\n\r\n\r\n/* CSS POUR DESCRIPTIONINPUT.JS */\r\n\r\n.inputDescriptionTitle.ant-input {\r\n  /* border-bottom: 1.5px solid #E0E0E0;  */\r\n  transition: border-color 0.3s ease;\r\n  border-radius: 0;\r\n  box-shadow: none;\r\n  font-family: 'Roboto';\r\n    font-weight: 400;\r\n    font-size: 11pt;\r\n    padding: 0;\r\n}\r\n/* Style quand le champ est en focus */\r\n.inputDescriptionTitle.ant-input:focus,\r\n.inputDescriptionTitle.ant-input-focused {\r\n  border-bottom: 2px solid #4C2B87; \r\n  /* box-shadow: none; */\r\n  line-height: 1.5;\r\n  letter-spacing: 0;\r\n  padding: 2%;\r\n  /* outline: none; */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
